import { gsap } from '../lib/gsap';

const initSplash = (element) => {
    const splashPlayed = sessionStorage.getItem('splashShown');

    if (splashPlayed) {
        element.remove();
    } else {
        const logo = document.querySelector('.js-splash-logo');
        const heroMedia = document.querySelector('.js-hero-media');
        const tagline = document.querySelector('.js-tagline');

        gsap.set(logo, {
            y: '50%',
            opacity: 0
        });

        gsap.set(heroMedia, {
            scale: 1.75,
            rotate: -2
        });

        gsap.set(tagline, {
            y: '100%',
            rotate: 5
        });

        const splashTl = gsap.timeline({
            defaults: {
                ease: 'power3.out',
                duration: 0.75
            },
            onStart: () => {
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                document.body.classList.add('stop-scrolling');
                document.body.setAttribute('data-lenis-prevent', 'true')
            },
            onComplete: () => {
                document.body.classList.remove('stop-scrolling');
                document.body.removeAttribute('data-lenis-prevent');

                element.classList.add('finish');
                sessionStorage.setItem('splashShown', true);
            }
        });

        splashTl.to(logo, {
            y: 0,
            opacity: 1,
            delay: 0.75,
        }).to(logo, {
            delay: 0.5,
            opacity: 0,
            scale: 0
        }).to(element, {
            scaleY: 0,
            duration: 1,
            delay: -0.5,
            ease: 'power4.out'
        }).to(heroMedia, {
            scale: 1,
            rotate: 0,
            duration: 1.75,
            delay: -1.5,
            ease: 'power4.out'
        }).to(tagline, {
            delay: -0.5,
            y: 0,
            rotate: 0
        });
    }
};

export { initSplash as default };
